<template>
    <div>
        <van-nav-bar    title="基地列表"  left-text="返回" @click-left="back"    left-arrow/>
        <van-list  class='pt46' v-model="loading"  :error.sync="error"  error-text="请求失败，点击重新加载" :finished='finished'  finished-text="没有更多了"  @load="getBaseList">
            <van-pull-refresh v-model="isRefresh" @refresh="onRefresh" loading-text='加载中...'>
                <van-panel @click="toDetails(item)" v-for="(item,index) in baseList" :key="index" :title="item.node" :desc="item.name" :status="item.price+'元/斤'">
                </van-panel>
                <!-- <van-cell  v-for="(item,index) in baseList" :key="index" :title="item.title" @click="toDetails(item)"  /> -->
            </van-pull-refresh>
        </van-list>
    </div>
</template>

<script>
import {getBaseListArr} from '@/request/data'
export default {
    name:'baseList',
    data() {
        return {
            baseList:[],
            page:0,
            per_page:15,
            loading:false,
            error:false,
            finished:false,
            isRefresh:false,
        }
    },
    mounted() {        
        this.baseList = []
        this.getBaseList()
    },
    methods: {
        getBaseList(){            
            this.loading = true
            let data = {}
            this.page +=1
            data.page = this.page
            data.per_page = this.per_page
            getBaseListArr(data).then(res=>{
                this.loading = false
                this.isRefresh = false
                if (res.data.code == 0) {                    
                    if (res.data.data.data.length > 0) {
                        for (let i = 0; i < res.data.data.data.length; i++) {
                            this.baseList.push(res.data.data.data[i])                            
                        }
                        // this.newsList.push.apply(res.data.data.data)
                        console.log(this.baseList)
                    }else{
                        this.finished = true
                    }
                }
                
            })
        },
        onRefresh(){
            this.isRefresh = true
            this.finished = false
            this.baseList = []
            this.page = 0
            this.getBaseList()                   
           
        },
        toDetails(item){
            
            this.$router.push({name:'traceability',query:{id:item.id}});
        },
        back(){
            this.$router.back(-1)
        }
    },
}
</script>

<style  scoped>
.main{ position:relative; width:100%; top:46px; bottom:0;overflow:auto;}
</style>